import { render, staticRenderFns } from "./KnowledgeGroupSelect.vue?vue&type=template&id=5f71c86e&"
import script from "./KnowledgeGroupSelect.vue?vue&type=script&lang=js&"
export * from "./KnowledgeGroupSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports